import { useState } from "react";
import { Button, Card, Input, Tag } from "antd";
import { AxiosError } from "axios";
import { useLocation } from "react-router-dom";
import TagsList from "../../Components/TagsList";
import { updateCompanyFieldsById } from "../../ducks/services";
import SuccessMessage from "../../../../../atoms/Toasts/SuccessMessage";
import ErrorMessage from "../../../../../atoms/Toasts/ErrorMessage";
import { useAppDispatch } from "../../../../../config/hooks";
import { getCompanyFieldsById } from "../../ducks/actions";
import EmptyCard from "../../../../../atoms/EmptyCard";

interface PropsType {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  data: { module: string; name: string; color?: string; id: string }[] | null;
  title: string;
  description: string;
  moduleName: string;
  changeColor?: boolean;
}

export default function TagsCard(props: PropsType) {
  const { setLoading, data, title, description, moduleName, changeColor } =
    props;
  const dispatch = useAppDispatch();
  const url = useLocation();
  const companyId = url?.pathname.split("/")[3];
  const [searchTerm, setSearchTerm] = useState("");

  const filteredItems =
    data?.filter((item: { name: string; module: string }) =>
      item?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  const createTag = (
    moduleName: string,
    tagName: string,
    colorName: string
  ) => {
    const payload = {
      id: undefined,
      company_id: companyId,
      module: moduleName,
      name: tagName,
      value: tagName?.replace(/ /g, "_"),
      color: colorName,
    };

    updateCompanyFieldsById(payload)
      .then(() => {
        setLoading(false);
        setSearchTerm("");
        SuccessMessage("Tag added.");

        const payload = {
          company_id: companyId,
        };

        dispatch(getCompanyFieldsById(payload));
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  return (
    <Card className="tags_card">
      <h3>{title}</h3>
      <p>{description}</p>

      <div className="tags_input">
        <Input
          placeholder="Search tag or create a new one"
          allowClear
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          // onPressEnter={() => {
          //   if (searchTerm && filteredItems.length === 0) {
          //     createTag(moduleName, searchTerm, "default_tag");
          //   }
          // }}
          onPressEnter={() => {
            const trimmed = searchTerm.trim();
            if (trimmed && filteredItems.length === 0) {
              createTag(moduleName, trimmed, "default_tag");
            }
          }}
        />
      </div>
      <div className="tags_wrap">
        {searchTerm && (
          <Button
            type="text"
            // onClick={() => createTag(moduleName, searchTerm, "default_tag")}
            onClick={() => {
              const trimmed = searchTerm.trim();
              if (trimmed) {
                createTag(moduleName, trimmed, "default_tag");
              }
            }}
            className="create_tag"
            disabled={filteredItems?.length > 0}
          >
            Create tag:{" "}
            <Tag color="#EFF2F3" style={{ color: "#98A3A9" }}>
              {searchTerm}
            </Tag>
          </Button>
        )}
        {filteredItems && filteredItems?.length > 0 && (
          <ul>
            {filteredItems?.map((item, index: number) => (
              <li key={index}>
                <TagsList
                  item={item}
                  companyId={companyId}
                  setLoading={setLoading}
                  moduleName={moduleName}
                  changeColor={changeColor}
                />
              </li>
            ))}
          </ul>
        )}

        {data && data.length === 0 && (
          <EmptyCard
            image="/images/empty-icons/no-archived.svg"
            title="There are no tags"
            description="To add one, enter a tag name to the field above."
            imageHeight={82}
          />
        )}
      </div>
    </Card>
  );
}
